import React, {Component} from "react"
import PropTypes from "prop-types"
import {Switch} from "react-router-dom"

import {NestedRoute} from "@irati/utils/history/routing"

import {AllRewards, RewardDetail, Rewards, CreateReward, CompletePayment} from "../containers"
import {CustomReward} from "../components/CustomReward"

export default class extends Component {
  static propTypes = {
    path: PropTypes.string.isRequired
  }

  render() {
    const {path} = this.props

    return (
      <Switch>
        <NestedRoute useGrid={false} exact path={`${path}`} title="Rewards" component={Rewards} />
        <NestedRoute useGrid={false} exact path={`${path}/all`} title="All rewards" component={AllRewards} />
        <NestedRoute useGrid={false} path={`${path}/success/:uuid`} title="Rewards Success" component={Rewards} />

        <NestedRoute useGrid={false} exact path={`${path}/add`} title="Reward" component={CreateReward} />
        <NestedRoute useGrid={false} exact path={`${path}/create`} title="Reward" component={CreateReward} />
        <NestedRoute useGrid={false} exact path={`${path}/custom-reward`} title="Custom Reward" component={CustomReward} />

        <NestedRoute
          exact
          path={`${path}/complete-payment/:rewardOrderId/:entityType/:entityId`}
          title="Complete Payment"
          component={CompletePayment} />

        <NestedRoute useGrid={false} exact path={`${path}/:slug`} title="Reward" component={RewardDetail} />
      </Switch>
    )
  }
}
